<div class="line-item-display">
	<div class="line-item-display__value line-item-display__value--description">
		<span>{{ lineItemFormGroup.value?.item?.name }}</span>
		<div><img *ngFor="let icon of icons" src="{{ icon?.src }}" height="20px" alt="{{ icon?.alt }}" /></div>
	</div>
	<div class="line-item-display__value">{{ lineItemFormGroup.value?.quantity }}</div>
	<div class="line-item-display__value">R{{ lineItemFormGroup.value?.unit_price }}</div>
	<div class="line-item-display__value">R{{ lineItemFormGroup.value?.total }}</div>
</div>
